export let qaConfig = [
    {
        section: "Section 1 Name Here", qa: [
            { question: "Question 1 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 2 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 3 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> }
        ]
    },
    {
        section: "Section 2 Name Here", qa: [
            { question: "Question 1 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 2 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 3 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> }
        ]
    },
    {
        section: "Section 3 Name Here", qa: [
            { question: "Question 1 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 2 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 3 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> }
        ]
    },
    {
        section: "Section 4 Name Here", qa: [
            { question: "Question 1 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 2 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> },

            { question: "Question 3 goes here", answer: <>answer goes here, should be component in case we need to do special typography formation</> }
        ]
    },

]